export interface Experiment {
  id: string;
  name: string;
  isJSExperiment: boolean;
  isVisitor: boolean;
  logTraits: boolean;
  conductForOldUsers: boolean;
  getAfterSwap: boolean;
  scope: string;
  variantNameArr: { [key: string]: string };
}

export const ABtestData = {
  DISABLE_TESTS: 'disabletests',
  RUNTEST: 'runtest',
};

interface PortalExperiments {
  [key: string]: Experiment;
}

export const deviceTypeRegex = {
  mobile: /mobile|android|iphone|ipad|ipod|Android|BlackBerry/i,
  desktop: /windows|macintosh|linux|mac os/i,
};

export enum ScopeDevices {
  mobile = 'mobile',
  desktop = 'desktop',
}

export const RMCPortalExperiments: PortalExperiments = {
  rmcUserInteractionDesktop: {
    id: 'c05f4c65-314e-4e28-a672-93a0a5c769a5',
    name: 'RMC User Intearcation Category Page Desktop V1 CVR',
    isJSExperiment: false,
    isVisitor: true,
    logTraits: true,
    conductForOldUsers: false,
    getAfterSwap: false,
    scope: 'desktop',
    variantNameArr: {
      '1': 'Baseline',
      '2': 'Variability Estimator',
      '3': 'job list redirection',
      '4': 'redirection and position',
      '5': 'similar jobs job details',
    },
  },
  rmcUserInteractionMobile: {
    id: '76b1fbcc-0fe9-4fb2-8070-b9f895f95efb',
    name: 'RMC User Intearcation Category Page Mobile V1 CVR',
    isJSExperiment: false,
    isVisitor: true,
    logTraits: true,
    conductForOldUsers: false,
    getAfterSwap: false,
    scope: 'mobile',
    variantNameArr: {
      '1': 'Baseline',
      '2': 'Variability Estimator',
      '3': 'job list redirection',
      '4': 'redirection and position',
      '5': 'similar jobs job details',
    },
  },
  rmcLocationFieldDesktop: {
    id: '4d3a4b74-85a7-492b-9dfe-9060708471b3',
    name: 'RMC Simplify location Desktop V1 CVR',
    isJSExperiment: false,
    isVisitor: true,
    logTraits: true,
    conductForOldUsers: false,
    getAfterSwap: false,
    scope: 'desktop',
    variantNameArr: {
      '1': 'Baseline',
      '2': 'Variability Estimator',
      '3': 'Location simplified',
    },
  },
  rmcLocationFieldMobile: {
    id: 'ac99a2c9-e3ac-4dd8-8ee8-acda9f7a695f',
    name: 'RMC Simplify location Mobile V1 CVR',
    isJSExperiment: false,
    isVisitor: true,
    logTraits: true,
    conductForOldUsers: false,
    getAfterSwap: false,
    scope: 'mobile',
    variantNameArr: {
      '1': 'Baseline',
      '2': 'Variability Estimator',
      '3': 'Location simplified',
    },
  },
  rmcDrawerDesktop: {
    id: '0fc34b52-9e71-4103-b197-d6905df86dfb',
    name: 'RMC Drawer Desktop V1 CVR',
    isJSExperiment: false,
    isVisitor: true,
    logTraits: true,
    conductForOldUsers: false,
    getAfterSwap: false,
    scope: 'desktop',
    variantNameArr: {
      '1': 'Baseline',
      '2': 'Variability Estimator',
      '3': 'Aggressive Drawer',
    },
  },
  rmcDrawerMobile: {
    id: 'e6a132b5-971b-416b-a803-5ad80b712bec',
    name: 'RMC Drawer Mobile V1 CVR',
    isJSExperiment: false,
    isVisitor: true,
    logTraits: true,
    conductForOldUsers: false,
    getAfterSwap: false,
    scope: 'mobile',
    variantNameArr: {
      '1': 'Baseline',
      '2': 'Variability Estimator',
      '3': 'Aggressive Drawer',
    },
  },
  rmcFreeJobsDesktop: {
    id: '91964117-2ac3-4b22-a899-d29fb6aabe23',
    name: 'RMC Remote Category  order of Jobs for free ALL  Desktop V1 CVR',
    isJSExperiment: false,
    isVisitor: true,
    logTraits: true,
    conductForOldUsers: false,
    getAfterSwap: false,
    scope: 'desktop',
    variantNameArr: {
      '1': 'Baseline',
      '2': 'Variability Estimator',
      '3': 'V1 - Reduced job for free',
    },
  },
  rmcFreeJobsMobile: {
    id: '2307874b-2c01-4ccb-9d6b-3ab6191c6fab',
    name: 'RMC Remote Category order of Jobs for free ALL Mobile V1 CVR',
    isJSExperiment: false,
    isVisitor: true,
    logTraits: true,
    conductForOldUsers: false,
    getAfterSwap: false,
    scope: 'mobile',
    variantNameArr: {
      '1': 'Baseline',
      '2': 'Variability Estimator',
      '3': 'V1 - Reduced job for free',
    },
  },
  rmcFreeJobsV2Desktop: {
    id: '057742c6-b449-43d6-83c6-f9257a8e5b5d',
    name: 'Reduction of Jobs for free Desktop CVR',
    isJSExperiment: false,
    isVisitor: true,
    logTraits: true,
    conductForOldUsers: false,
    getAfterSwap: false,
    scope: 'desktop',
    variantNameArr: {
      '1': 'Baseline',
      '2': 'Variability Estimator',
      '3': 'V1 - Reduced job for free	',
    },
  },
  rmcFreeJobsV2Mobile: {
    id: 'c5a46f3e-5d0f-4808-b76a-782a6a161d02',
    name: 'Reduction of Jobs for free Mobile CVR',
    isJSExperiment: false,
    isVisitor: true,
    logTraits: true,
    conductForOldUsers: false,
    getAfterSwap: false,
    scope: 'mobile',
    variantNameArr: {
      '1': 'Baseline',
      '2': 'Variability Estimator',
      '3': 'V1 - Reduced job for free',
    },
  },
  rmcPaywallDesktopMobile: {
    id: '324c0fe9-06a7-4366-9a5e-886466919f34',
    name: 'RMC Inset Paywall content All All V1 CVR',
    isJSExperiment: false,
    isVisitor: true,
    logTraits: true,
    conductForOldUsers: false,
    getAfterSwap: false,
    scope: 'desktop|mobile',
    variantNameArr: {
      '1': 'Baseline',
      '2': 'Variability Estimator',
      '3': 'NEW CONTENT',
      '4': 'SYNONYM PLUS',
    },
  },
};

export function getExperimentById(id: string): Experiment | undefined {
  return Object.values(RMCPortalExperiments).find(
    (experiment) => experiment.id === id
  );
}
